export default function SearchTips({ searchKey }: { searchKey: string }) {
  if (!searchKey.includes(" ")) return null;

  let part1 = searchKey.split(" ")[0];
  let part2 = searchKey.split(" ")[1];

  return <div></div>;

  return (
    <div className="c1 gray gap15 mtop20" style={{ marginTop: "150px" }}>
      <strong>Astuces</strong>
      <div>- Utilisez le début du nom et du prénom</div>
      <div>
        Example: pour &quot;{searchKey}&quot;, recherchez &quot;
        {part1?.slice(0, 4)} {part2?.slice(0, 4)}&quot;
      </div>
    </div>
  );
}
